import { Link } from "react-router-dom";
import { useGameStore } from "@/store/gameStore";

/**
 * Standalone result page (route /result). Currently unused in the main flow —
 * the in-game ResultOverlay covers the result UX. Kept as a fallback so the
 * route exists if we want to deep-link results later (brief Section 7.1).
 */
export function ResultPage() {
  const sim = useGameStore((s) => s.simResult);
  const streak = useGameStore((s) => s.streak);
  const shareCardText = useGameStore((s) => s.shareCardText);

  return (
    <main className="flex min-h-full flex-col items-center justify-center gap-4 p-6 text-center">
      {sim ? (
        <>
          <h1 className="text-3xl font-bold">{sim.outcome}</h1>
          {sim.outcome === "GOAL" && <p className="opacity-80">Score: {sim.score}</p>}
          {streak && <p className="opacity-70">Streak: {streak.current}</p>}
          {shareCardText && <p className="font-mono text-lg">{shareCardText}</p>}
        </>
      ) : (
        <p className="opacity-70">No attempt yet.</p>
      )}
      <Link to="/" className="underline opacity-80 hover:opacity-100">
        Home
      </Link>
    </main>
  );
}
